import { render, staticRenderFns } from "./UserRestorePassword.vue?vue&type=template&id=99de8a68&scoped=true"
import script from "./UserRestorePassword.vue?vue&type=script&lang=js"
export * from "./UserRestorePassword.vue?vue&type=script&lang=js"
import style0 from "./UserRestorePassword.vue?vue&type=style&index=0&id=99de8a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99de8a68",
  null
  
)

export default component.exports